<template>
  <div id="app">
    <!-- 如果是登录页，直接显示 -->
    <router-view v-if="$route.path === '/login'" />
    
    <!-- 其他页面使用原有结构 -->
    <div v-else class="app-wrapper">
      <!-- 加载遮罩层 -->
      <div v-if="!isRoutesReady" class="route-loading">
        <span>初始化中...</span>
      </div>

      <template v-else>
        <top-nav :top-menus="topMenus" />
        <div class="main-container">
          <side-nav :side-menus="sideMenus" />
          <div class="main-content">
            <tabs-view />
            <div class="content-wrapper">
              <router-view />
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import TopNav from '@/components/TopNav'
import SideNav from '@/components/SideMenu'
import TabsView from '@/components/TabView'
import { addDynamicRoutes } from '@/router'

export default {
  name: 'App',
  components: { TopNav, SideNav, TabsView},
  data() {
    return {
      isRoutesReady: false,
      initError: null
    }
  },
  computed: {
    topMenus() {
      return this.$store.getters.topMenus
    },
    sideMenus() {
      return this.$store.getters.sideMenus
    }
  },
  async created() {
    
    try {
      // 第一步：并行加载基础数据
      await Promise.all([
        this.$store.dispatch('user/getMenus'),
      ])

      // 第二步：严格等待动态路由完成
      const success = await addDynamicRoutes()
      if (!success) throw new Error('动态路由加载失败')

      // 第三步：初始化Tab
      await this.initTabs()

      this.isRoutesReady = true
    } catch (err) {
      console.error('应用初始化失败:', err)
      this.initError = err
    }
  },
  methods: {
     async initTabs() {
          //console.log('当前路径:', this.$route.path)
          // 排除不需要标签页的路由
          const excludePaths = ['/login', '/404']
          if (excludePaths.includes(this.$route.path)) {
            return
          }
          
          if (this.$route.path === '/') {
            await this.$router.replace('/home').catch(() => {})
            return
          }
          // 等待动态路由加载完成
          await this.$nextTick()
          
          

          if (!this.$route.matched.length) {
            console.log('当前matched为空')
            return
          }
          // 检查当前路由是否有效
          const currentPath = this.$route.path
          const matchedRoute = this.$router.getRoutes().find(r => r.path === currentPath)
          
          if (!matchedRoute) {
            console.warn(`路由 ${currentPath} 未找到，可能动态路由尚未加载`)
            
            // 等待一下再检查（给动态路由加载时间）
            setTimeout(async () => {
              const retryRoute = this.$router.getRoutes().find(r => r.path === currentPath)
              if (retryRoute) {
                // 重新添加标签页
                if (!this.$store.state.tab.visitedTabs.some(tab => tab.path === currentPath)) {
                  await this.$store.dispatch('tab/addTab', {
                    path: currentPath,
                    title: retryRoute.meta?.title || currentPath,
                    fullPath: this.$route.fullPath,
                    meta: retryRoute.meta
                  })
                }
              } else {
                console.error(`路由 ${currentPath} 确实不存在，跳转到首页`)
                this.$router.replace('/home')
              }
            }, 100)
            return
          }

          // 正常添加标签页的逻辑...
          if (!this.$store.state.tab.visitedTabs.some(tab => tab.path === currentPath)) {
            await this.$store.dispatch('tab/addTab', {
              path: currentPath,
              title: matchedRoute.meta?.title || currentPath,
              fullPath: this.$route.fullPath,
              meta: matchedRoute.meta
            })
          }
        }
    }
}
</script>

<style lang="scss">
.route-loading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.9);
  z-index: 9999;
}
.loading-icon {
  font-size: 48px;
  margin-bottom: 16px;
  animation: rotating 2s linear infinite;
}

.app-wrapper {
  display: flex;
  flex-direction: column;
  height: 100vh;
  
  .main-container {
    display: flex;
    flex: 1;
    overflow: hidden;
    
    .main-content {
      flex: 1;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      
      .content-wrapper {
        flex: 1;
        padding: 16px;
        overflow: auto;
        background: #f0f2f5;
      }
    }
  }
}

@keyframes rotating {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* 重置可能冲突的样式 */
#app {
  height: 100vh;
  overflow: hidden;
}

/* 确保登录页全屏 */
.login-container {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  z-index: 9999 !important;
}
</style>